"use strict";

var _slicedToArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module index
 */

var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");

var generic_1 = require("../generic");

var marshall_1 = require("@waves/marshall");

var validators_1 = require("../validators");

function order(paramsOrOrder, seed) {
  var amountAsset = generic_1.isOrder(paramsOrOrder) ? paramsOrOrder.assetPair.amountAsset : paramsOrOrder.amountAsset;
  var priceAsset = generic_1.isOrder(paramsOrOrder) ? paramsOrOrder.assetPair.priceAsset : paramsOrOrder.priceAsset;
  var proofs = generic_1.isOrder(paramsOrOrder) ? paramsOrOrder.proofs : [];
  var matcherFee = paramsOrOrder.matcherFee,
      matcherPublicKey = paramsOrOrder.matcherPublicKey,
      price = paramsOrOrder.price,
      amount = paramsOrOrder.amount,
      orderType = paramsOrOrder.orderType,
      expiration = paramsOrOrder.expiration,
      timestamp = paramsOrOrder.timestamp;
  var t = timestamp || Date.now();
  var seedsAndIndexes = generic_1.convertToPairs(seed);
  var senderPublicKey = paramsOrOrder.senderPublicKey || generic_1.getSenderPublicKey(seedsAndIndexes, paramsOrOrder); // Use old versionless order only if it is set to null explicitly

  var version = paramsOrOrder.version === null ? undefined : paramsOrOrder.version || 2;
  var ord = {
    orderType: orderType,
    version: version,
    assetPair: {
      amountAsset: amountAsset,
      priceAsset: priceAsset
    },
    price: price,
    amount: amount,
    timestamp: t,
    expiration: expiration || t + 29 * 24 * 60 * 60 * 1000,
    matcherFee: matcherFee || 300000,
    matcherPublicKey: matcherPublicKey,
    senderPublicKey: senderPublicKey,
    proofs: proofs,
    id: ''
  };

  if (ord.version === 3) {
    ord.matcherFeeAssetId = paramsOrOrder.matcherFeeAssetId === 'WAVES' ? null : paramsOrOrder.matcherFeeAssetId;
  }

  var bytes = marshall_1.binary.serializeOrder(ord);
  seedsAndIndexes.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        s = _ref2[0],
        i = _ref2[1];

    return generic_1.addProof(ord, ts_lib_crypto_1.signBytes(s, bytes), i);
  });
  validators_1.validate.order(ord);
  ord.id = ts_lib_crypto_1.base58Encode(ts_lib_crypto_1.blake2b(bytes)); // OrderV1 uses signature instead of proofs

  if (ord.version === undefined || ord.version === 1) ord.signature = ord.proofs && ord.proofs[0];
  return ord;
}

exports.order = order;